import { cn } from '@/lib/utils';
import { Loader2, MessageCircle } from 'lucide-react';

type LiveCommentsFabProps = {
  isLoading: boolean;
  unread: number;
  onOpen: () => void;
};

export function LiveCommentsFab({ isLoading, unread, onOpen }: LiveCommentsFabProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      disabled={isLoading}
      aria-label={isLoading ? 'Loading comments…' : 'Open comments'}
      aria-busy={isLoading || undefined}
      className={cn(
        'fixed bottom-3 right-3 z-[1400] flex items-center gap-1.5 rounded-full bg-blue-600 px-3 py-2 text-white shadow-lg',
        'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400',
        'disabled:cursor-not-allowed disabled:opacity-60 sm:bottom-4 sm:right-4 sm:gap-2 sm:px-4 sm:py-2.5',
      )}
    >
      <div className="relative">
        {isLoading ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : (
          <>
            <MessageCircle className="h-5 w-5" />
            {unread > 0 && (
              <span className="absolute -top-2 -right-3 inline-flex min-w-[18px] items-center justify-center rounded-full bg-red-500 px-1 py-0.5 text-[10px] font-semibold">
                {unread > 99 ? '99+' : unread}
              </span>
            )}
          </>
        )}
      </div>
      <span className="text-xs font-medium sm:text-sm">
        {isLoading ? 'Loading…' : 'Comments'}
      </span>
    </button>
  );
}
